module.exports = __webpack_public_path__ + "media/images/lp/lp02-84c55778f85ff1d9cd9fb07e0ace7b4e.webp";